import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Link, ContentfulImage, MOBILE } from 'chemistry'

const CategoryBanner = () => {
  const banner = useSelector(state => state.data.banner)
  if (!banner) return <div id='banner-widget-container' style={{ width: '100%' }} /> // for GTM
  const { title, subTitle, link, image } = banner

  if (!image?.image?.url) return null

  return (
    <div id='banner-widget-container' className='mxd-lister-widgets'>
      <ContentfulImage image={image} />
      {(title || subTitle) && (
        <Link
          href={link || '#'}
          className='flex justify-center items-center flex-column'
          sx={{
            fontFamily: 'bold',
            color: 'offYellow.500',
            _hover: {
              color: 'offYellow.500'
            }
          }}
        >
          {title && (
            <Box
              as='span'
              sx={{
                fontSize: '4xl',
                [MOBILE]: {
                  fontSize: '2xl'
                }
              }}
            >
              {title}
            </Box>
          )}
          {subTitle && (
            <Box
              as='span'
              sx={{
                fontSize: 'xl',
                [MOBILE]: {
                  fontSize: 'sm'
                }
              }}
            >
              {subTitle}
            </Box>
          )}
        </Link>
      )}
    </div>
  )
}

export default React.memo(CategoryBanner)
